import isEqual from 'utils/isEqual';

export const getCookie = (name) => {
	if (typeof window === 'undefined')return undefined;
	if (typeof document === 'undefined')return undefined;
	const cookie = document.cookie.split('; ').find(value => value.startsWith(`${name}=`))?.split('=');
	if (!!cookie === false)return undefined;
	let value;
	try {
		value = JSON.parse(cookie[1], (key, value) => {
			const ISO8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
			if (ISO8601.test(value))return new Date(value);
			return value;
		});
	}
	catch (err) { 
		value = cookie[1];
	};
	return value;
}

export const setCookie = (name, value, age = 31536000) => {
	if (typeof window === 'undefined')return undefined;
	if (typeof document === 'undefined')return undefined;
	if (typeof value === 'object') {
		value = JSON.stringify(value);
	}
	document.cookie = `${name}=${value};max-age=${age}`;
}

export const saveLocalStorage = (name, value) => {
	if (typeof window === 'undefined' || window.localStorage === undefined)return;
	window.localStorage.setItem(name, JSON.stringify(value));
}

export const updateLocalStorage = (name, props) => {
	let didChange = false;
	if (typeof window === 'undefined' || window.localStorage === undefined)return;
	const current = JSON.parse(window.localStorage.getItem(name));
	const next = {...current, ...props};
	saveLocalStorage(name, next);
	if (!isEqual(current, next)) {
		didChange = true;
	}
	return { didChange, next, current };
}

export const readLocalStorage = (name) => {
	if (typeof window === 'undefined' || window.localStorage === undefined)return;
	if (!!window.localStorage.getItem(name) === false)return null;
	return JSON.parse(window.localStorage.getItem(name), (key, value) => {
		if (value === "null")return null;
		if (value === "undefined")return undefined;
		const ISO8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/i;
		if (ISO8601.test(value))return new Date(value);
		return value;
	});
}